import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import { PageLoading } from '@bumble/app/components/PageLoading';
import { ThirdPartyIntegrationForm } from '@bumble/app/components/ThirdPartyIntegrationForm';
import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

interface RouterExternalApiIntegrationEditProps {
  onSubmit: () => void;
  cpeId: string;
}

export const RouterExternalApiIntegrationEdit = ({ onSubmit, cpeId }: RouterExternalApiIntegrationEditProps) => {
  const api = useApi();

  const { isLoading, data } = useQuery(
    ['get3rdPartyIntegration', cpeId],
    api.get3RdpartyIntegrationApiV1Get3RdpartyIntegrationGet.bind(null, { cpe_id: cpeId }),
    { enabled: true, cacheTime: 0 },
  );

  const configureIntegration = useMutation(api.configure3RdpartyIntegrationApiV1Configure3RdpartyIntegrationPost, {
    onSuccess() {
      toast.success('External API integration saved successfully.');
      onSubmit();
    },
    onError: apiError,
  });

  const handleSubmit = (vendor: string, config: { key: string; value: string }[]) => {
    configureIntegration.mutate({ cpe_id: cpeId, vendor, config });
  };

  if (isLoading) return <PageLoading content="Loading integration settings..." />;

  return (
    <>
      {configureIntegration.isLoading && <PageLoading content="Saving..." />}
      <ThirdPartyIntegrationForm
        vendors={data?.data ?? []}
        fieldsDisabled
        submitting={configureIntegration.isLoading}
        onSubmit={handleSubmit}
      />
    </>
  );
};
